import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { APP_CONFIG } from '../../config/app.config.constants';
import { TrackingService } from '../../services/tracking.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-section">
            <div class="footer-brand">
              <img [src]="APP_CONFIG.IMAGES.LOGO" alt="Kalaivani Logo" class="brand-icon">
              <div class="brand-info">
                <span class="brand-text">Kalaivani</span>
                <span class="brand-tagline">The Voice of Smart School Management</span>
              </div>
            </div>
            <p class="footer-description">
              Empowering preschools with comprehensive management solutions for the digital age.
            </p>
            <div class="contact-info">
              <a href="tel:+917550196844" class="contact-link" (click)="onPhoneClick()">
                <svg class="contact-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span>+91 75501 96844</span>
              </a>
              <a href="mailto:enquiry@kalaivani.in" class="contact-link" (click)="onEmailClick()">
                <svg class="contact-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span>enquiry&#64;kalaivani.in</span>
              </a>
            </div>
            <div class="social-links">
              <a [href]="APP_CONFIG.SOCIAL_MEDIA.FACEBOOK" aria-label="Facebook" class="social-link" target="_blank" rel="noopener noreferrer">
                <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" width="20" height="20">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
                </svg>
              </a>
              <a [href]="APP_CONFIG.SOCIAL_MEDIA.LINKEDIN" aria-label="LinkedIn" class="social-link" target="_blank" rel="noopener noreferrer">
                <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" width="20" height="20">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" d="M4 6a2 2 0 100-4 2 2 0 000 4z"/>
                </svg>
              </a>
              <a [href]="APP_CONFIG.SOCIAL_MEDIA.YOUTUBE" aria-label="YouTube" class="social-link" target="_blank" rel="noopener noreferrer">
                <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" width="20" height="20">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"/>
                </svg>
              </a>
              <a [href]="APP_CONFIG.SOCIAL_MEDIA.TWITTER" aria-label="Twitter" class="social-link" target="_blank" rel="noopener noreferrer">
                <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" width="20" height="20">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"/>
                </svg>
              </a>
              <a [href]="APP_CONFIG.SOCIAL_MEDIA.INSTAGRAM" aria-label="Instagram" class="social-link" target="_blank" rel="noopener noreferrer">
                <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" width="20" height="20">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </div>
          </div>

          <div class="footer-section">
            <h3 class="footer-title">Product</h3>
            <ul class="footer-links">
              <li><a routerLink="/features">Features</a></li>
              <li><a routerLink="/benefits">Benefits</a></li>
              <li><a routerLink="/pricing">Pricing</a></li>
              <li><a routerLink="/demo">Try Demo</a></li>
              <li><a routerLink="/signup">Get Started</a></li>
            </ul>
          </div>

          <div class="footer-section">
            <h3 class="footer-title">Company</h3>
            <ul class="footer-links">
              <li><a routerLink="/contact">Contact Us</a></li>
              <li><a routerLink="/contact">About Us</a></li>
            </ul>
          </div>

          <div class="footer-section">
            <h3 class="footer-title">Contact</h3>
            <ul class="footer-links">
              <li>
                <a href="tel:+917550196844" class="contact-link-inline" (click)="onPhoneClick()">
                  <svg class="contact-icon-small" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  +91 75501 96844
                </a>
              </li>
              <li>
                <a href="mailto:enquiry@kalaivani.in" class="contact-link-inline" (click)="onEmailClick()">
                  <svg class="contact-icon-small" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  enquiry&#64;kalaivani.in
                </a>
              </li>
              <li class="address-text">
                1237, 2nd Floor, Subbulakshmi Nagar<br>
                Landmark: HDFC Bank<br>
                Chennai, Pincode: 600132
              </li>
            </ul>
          </div>
        </div>

        <div class="footer-bottom">
          <p>&copy; 2026 Kalaivani.in. All rights reserved. A Unit of Tamilarasi Technologies Private Limited</p>
          <div class="footer-legal">
            <a routerLink="/privacy">Privacy Policy</a>
            <span>•</span>
            <a routerLink="/terms">Terms of Service</a>
            <span>•</span>
            <a routerLink="/cookie">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  `,
  styles: [`
    .footer {
      background: var(--gradient-primary);
      color: white;
      padding: 60px 20px 30px;
      
      @media (max-width: 768px) {
        padding: 40px 16px 24px; /* Reduced top padding from 60px, sides from 20px */
      }
      
      @media (max-width: 480px) {
        padding: 32px 12px 20px; /* Further reduced for very small screens */
      }
    }

    .container {
      max-width: 1400px;
      margin: 0 auto;
    }

    .footer-content {
      display: grid;
      grid-template-columns: 2fr 1fr 1fr 1fr;
      gap: 48px;
      margin-bottom: 48px;
      
      @media (max-width: 768px) {
        gap: 32px; /* Reduced from 48px */
        margin-bottom: 32px; /* Reduced from 48px */
      }
      
      @media (max-width: 480px) {
        gap: 24px; /* Further reduced */
        margin-bottom: 24px;
      }
    }

    .footer-brand {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 16px;
    }

    .brand-icon {
      height: 50px;
      width: auto;
      object-fit: contain;
      flex-shrink: 0;
    }

    .brand-info {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .brand-text {
      font-size: 1.5rem;
      font-weight: 700;
      color: white;
    }

    .brand-tagline {
      font-size: 0.875rem;
      color: rgba(255, 255, 255, 0.7);
      font-weight: 400;
    }

    .footer-description {
      color: rgba(255, 255, 255, 0.8);
      line-height: 1.6;
      margin-bottom: 24px;
      
      @media (max-width: 768px) {
        font-size: 0.9375rem; /* Slightly reduced */
        margin-bottom: 20px; /* Reduced from 24px */
      }
    }

    .contact-info {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-bottom: 24px;
    }

    .contact-link {
      display: flex;
      align-items: center;
      gap: 10px;
      color: rgba(255, 255, 255, 0.9);
      text-decoration: none;
      font-size: 0.9rem;
      transition: color 0.3s ease;
    }

    .contact-link:hover {
      color: white;
    }

    .contact-icon {
      width: 18px;
      height: 18px;
      flex-shrink: 0;
    }

    .social-links {
      display: flex;
      gap: 12px;
    }

    .social-link {
      width: 44px; /* Increased from 40px to meet touch target minimum */
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 8px;
      color: rgba(255, 255, 255, 0.9);
      transition: all 0.3s ease;
      min-width: 44px; /* Ensure touch-friendly size */
      min-height: 44px;
    }

    .social-link:hover {
      background: rgba(255, 255, 255, 0.2);
      color: white;
      transform: translateY(-2px);
    }

    .footer-title {
      font-size: 1.125rem;
      font-weight: 600;
      margin-bottom: 20px;
      
      @media (max-width: 768px) {
        font-size: 1rem; /* Reduced from 1.125rem */
        margin-bottom: 16px; /* Reduced from 20px */
      }
    }

    .footer-links {
      list-style: none;
      display: flex;
      flex-direction: column;
      gap: 12px;
      padding: 0;
      margin: 0;
      
      @media (max-width: 768px) {
        gap: 10px; /* Reduced from 12px */
      }
      
      li a {
        min-height: 44px; /* Ensure touch-friendly size */
        display: flex;
        align-items: center;
      }
    }

    .footer-links a {
      color: rgba(255, 255, 255, 0.8);
      text-decoration: none;
      transition: color 0.3s ease;
    }

    .footer-links a:hover {
      color: white;
    }

    .contact-link-inline {
      display: flex;
      align-items: center;
      gap: 8px;
      color: rgba(255, 255, 255, 0.8);
      text-decoration: none;
      transition: color 0.3s ease;
    }

    .contact-link-inline:hover {
      color: white;
    }

    .contact-icon-small {
      width: 16px;
      height: 16px;
      flex-shrink: 0;
    }

    .address-text {
      color: rgba(255, 255, 255, 0.8);
      font-size: 0.9rem;
      line-height: 1.6;
      margin-top: 4px;
    }

    .footer-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 32px;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      color: rgba(255, 255, 255, 0.6);
      font-size: 0.9rem;
    }

    .footer-legal {
      display: flex;
      gap: 12px;
      align-items: center;
    }

    .footer-legal a {
      color: rgba(255, 255, 255, 0.6);
      transition: color 0.3s ease;
    }

    .footer-legal a:hover {
      color: white;
    }

    .footer-legal span {
      color: rgba(255, 255, 255, 0.4);
    }

    @media (max-width: 968px) {
      .footer-content {
        grid-template-columns: 1fr 1fr;
        gap: 40px;
      }
    }

    @media (max-width: 768px) {
      .footer-content {
        grid-template-columns: 1fr;
        gap: 28px; /* Reduced from 32px */
      }

      .footer-bottom {
        flex-direction: column;
        gap: 12px; /* Reduced from 16px */
        text-align: center;
        padding-top: 24px; /* Reduced from 32px */
        font-size: 0.875rem; /* Slightly reduced */
      }

      .footer-legal {
        flex-wrap: wrap;
        justify-content: center;
        gap: 8px; /* Reduced gap between items */
        font-size: 0.875rem;
      }
      
      .brand-text {
        font-size: 1.25rem; /* Reduced from 1.5rem */
      }
      
      .brand-tagline {
        font-size: 0.8125rem; /* Reduced from 0.875rem */
      }
      
      .contact-link {
        font-size: 0.875rem; /* Reduced from 0.9rem */
        min-height: 44px; /* Ensure touch-friendly size */
      }
    }
    
    @media (max-width: 480px) {
      .footer-content {
        gap: 24px; /* Further reduced */
      }
      
      .footer-bottom {
        padding-top: 20px;
        font-size: 0.8125rem;
      }
      
      .footer-legal {
        font-size: 0.8125rem;
      }
    }
  `]
})
export class FooterComponent {
  private readonly trackingService = inject(TrackingService);
  
  APP_CONFIG = APP_CONFIG;
  currentYear = new Date().getFullYear();

  onPhoneClick(): void {
    this.trackingService.trackPhoneClick('footer_phone');
  }

  onEmailClick(): void {
    this.trackingService.trackEmailClick('footer_email');
  }
}

